import "../styles/globals.css";
import "nprogress/nprogress.css";
import "../styles/font/golostext.css";
import "../styles/font/gilroy.css";
import "../styles/font/manrope.css";

import Router from "next/router";
import NProgress from "nprogress";
import { useEffect } from "react";

import { Api } from "~/api";

import { wrapper } from "../redux";

Router.events.on("routeChangeStart", () => NProgress.start());
Router.events.on("routeChangeComplete", () => NProgress.done());
Router.events.on("routeChangeError", () => NProgress.done());

function MyApp({ Component, pageProps }: any) {
  useEffect(() => {
    const reportMetrics = async () => {
      const [paintFCP] = performance.getEntriesByName("first-contentful-paint");
      const hydrationEntry = performance.getEntriesByName(
        "Farkop.js-hydration",
      )[0];

      const timeToFirstByte =
        performance.timing.responseStart - performance.timing.requestStart;
      const totalLoadTime = Math.round(performance.now()); // from navigation start
      const firstContentfulPaint = Math.round(paintFCP?.startTime) || 0;
      const hydrationTime = Math.round(hydrationEntry?.duration) || 0;

      await Api.server.sentMetric({
        type: "pageLoad",
        url: window.location.pathname,
        serverSideRenderingTime: pageProps.serverSideRenderingTime || 0, // ssr rendering time
        timeToFirstByte, //  Time to First Byte
        firstContentfulPaint, //	First Contentful Paint
        hydrationTime, // 	Время гидрации (Next.js)
        totalLoadTime, //	Время до полной загрузки
      });
    };

    const sendOnLoad = () => {
      try {
        performance.mark("hydration-start");
        requestIdleCallback(() => {
          performance.mark("hydration-end");
          performance.measure(
            "Farkop.js-hydration",
            "hydration-start",
            "hydration-end",
          );
          reportMetrics();
        });
      } catch (e) {
        console.warn("Sent metric error", e);
      }
    };

    // if (typeof document !== "undefined" && document.readyState === "complete") {
    //   sendOnLoad();
    // } else if (typeof window !== "undefined") {
    window.addEventListener("load", sendOnLoad);
    return () => window.removeEventListener("load", sendOnLoad);
    // }
  }, []);
  return <Component {...pageProps} />;
}

export default wrapper.withRedux(MyApp);
